import { useTranslation } from "providers/i18n"
import { FeatureActionContainer } from "containers/FeatureActionContainer"

import {
  Card,
  styled,
  Box,
  Typography,
  Stack,
  Skeleton,
  useTheme,
  CardMedia,
} from "@mui/material"
import { StoreIcon } from "components/icons"
import { getIcon } from "utils/icon"

const ShortInfoWrapper = styled(Card)(({ theme }) => ({
  display: "flex",
  gap: theme.spacing(2),
  boxShadow: "none",
}))

const ShortInfoActionWrapper = styled(Stack)(({ theme }) => ({
  paddingBottom: theme.spacing(3),
  paddingTop: theme.spacing(1),
}))

const LoadingFeature = () => {
  return (
    <Box>
      <ShortInfoWrapper>
        <Skeleton variant="circular" width={80} height={80} />
        <Box>
          <Skeleton variant="text" width={180} />
          <Stack spacing={0.5} sx={{ mb: 1 }}>
            <Skeleton variant="text" width={80} />
            <Skeleton variant="text" width={80} />
          </Stack>
          <Skeleton variant="text" width={150} />
        </Box>
      </ShortInfoWrapper>
      <ShortInfoActionWrapper direction={"row"} spacing={2}>
        <Skeleton variant="text" width={70} height={40} />
        <Skeleton variant="text" width={70} height={40} />
      </ShortInfoActionWrapper>
    </Box>
  )
}

export const FeatureSummary = ({ DirectionButtonProps, ...props }) => {
  const { t } = useTranslation({ defaultValue: null })
  const theme = useTheme()
  const styleOverrides =
    theme.components[`FeatureSummary`]?.styleOverrides || {}
  const {
    root,
    container,
    infoSection,
    title,
    logoContainer,
    venueLogoContainer,
    logoImage,
    venueLogoImage,
    categoryIcon,
  } = styleOverrides
  const {
    logo,
    venueLogo,
    phone,
    name,
    id,
    loading,
    onNavigate,
    categoryIconProp = {},
    isNavigatable = true,
  } = props
  const nameText = t(name)

  if (loading) return <LoadingFeature />
  return (
    <Stack
      className="FeatureSummary-root"
      justifyContent="space-between"
      sx={root}
    >
      <Box sx={infoSection}>
        <Typography variant="title" component="h3" sx={title}>
          {nameText}
        </Typography>
      </Box>
      <Card sx={container}>
        <Box sx={logoContainer}>
          {logo ? (
            <CardMedia
              component="img"
              image={logo || categoryIconProp?.image}
              sx={logoImage}
            />
          ) : (
            getIcon(categoryIconProp, categoryIcon, {
              imageIconProps: {
                solidColorFilterId: "placeDetail_avatar_filter",
              },
            }) || <StoreIcon />
          )}
        </Box>
        {venueLogo && (
          <Box sx={venueLogoContainer}>
            <CardMedia component="img" image={venueLogo} sx={venueLogoImage} />
          </Box>
        )}
      </Card>
      <FeatureActionContainer
        destinationId={id}
        phone={phone}
        onNavigate={onNavigate}
        DirectionButtonProps={{
          isHidden: !isNavigatable,
          ...DirectionButtonProps,
        }}
      />
    </Stack>
  )
}
